import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import { useHistory } from "react-router-dom";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import Cookies from "js-cookie"
import ExpandCommand from "../../Commands/ExpandCommand/ExpandCommand";
import CollapseCommand from "../../Commands/CollapseCommand/CollapseCommand";
import TaskIcon from "../../Commands/TaskIcon/TaskIcon";
import FormIcon from "../../Commands/FormIcon/FormIcon";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import Tree from "../../Tree/Tree";

export default function  Process (props) {
  const globalState = useContext(store);
  return (
    <div style ={{ border:"none", minWidth: "302px", maxWidth: "302px", overflow: "auto"}}>
          <Tree 
            backgroundColor = "transparent"
            onCheckedItem = {(checkeds, dataLabel, menuPaths) =>  {}}
            withCheckBox = {false} 
            menuItems = {[...globalState.state.variables.users, ...globalState.state.variables.times]}/>
       </div>
  );
};

/*
<span style = {{ fontSize:"14px", width:"250px", color:"#212121" }} >Register</span>*/